import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view.
export const Reveal = ({ children, delay = 0, y = 40, className = "", as }) => {
  const Comp = motion[as || "div"];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </Comp>
  );
};

// Line-by-line masked heading reveal.
export const MaskedHeading = ({ lines, className = "", lineClassName = "", delay = 0, as = "div" }) => {
  const Comp = as;
  return (
    <Comp className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: 60, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, ease, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Comp>
  );
};
